import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';

import Field from 'core/components/form/form.v2';
import { AppliedTag } from 'common/components/farm/applied-tag';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const SprinklerLeakageForm = ({ fieldName, disabled }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const isApplied = !!getIn(values, `${fieldName}.sprinklerLeakageBuildingLimit`);

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Sprinkler leakage</div>}
      contentRight={isApplied ? <AppliedTag /> : null}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={12}
          id={`${fieldName}.sprinklerLeakageBuildingLimit`}
          name={`${fieldName}.sprinklerLeakageBuildingLimit`}
          type="numeric"
          format={{ thousandSeparator: true, prefix: '$' }}
          mode="dark"
          label="Amount of insurance"
          disabled={disabled}
        />
        <Field
          id={`${fieldName}.sprinklerLeakageLimitDetails`}
          name={`${fieldName}.sprinklerLeakageLimitDetails`}
          type="textarea"
          mode="dark"
          label="Description of premise (required)"
          xs={12}
          rows={3}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

SprinklerLeakageForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

SprinklerLeakageForm.defaultProps = {
  disabled: false
};

export default observer(SprinklerLeakageForm);
